import { Datalayer, DatalayersMap } from "../../../omnia"

import IMapTopologyService = omnia.map.IMapTopologyService
import { ol_Feature, ol_geom, ol_GeometryType } from "@omnia/exports/openlayers"

export class AddOperation {

    constructor(private map: DatalayersMap, private layer: Datalayer, private topo: IMapTopologyService, private _outerGeometry: () => ol_geom.Geometry) {
    }

    get outerGeometry() {
        return this._outerGeometry()
    }

    start(type: ol_GeometryType = "Polygon") {
        this.map.startDrawingNewFeature(this.layer, type)
    }

    stop() {
    }

    public commit(): boolean {

        if (!this.canCommit()) return false

        const feature = this.map.commitEdit()
        if (!(feature instanceof ol_Feature)) return false

        const geometry = this.topo.intersection(this.outerGeometry, feature.getGeometry())
        if (!geometry) return false
        if (!geometry.isValid()) return false

        return insertNewGeometry(geometry.getOpenLayersGeometry(), this.layer, this.topo, false)

    }

    public canCommit() {
        return this.map.getEditMode() && this.map.canCommit()
    }

}

export function insertNewGeometry(geometry: ol_geom.Geometry, layer: Datalayer, topo: IMapTopologyService, splitOnExistingZones: boolean, minimumArea: number = 1) {

    return omnia.map.insertNewGeometry(
        geometry,
        layer,
        topo,
        (g, z) => {
            const nz = layer.createNewZoneWithGeometry(g)
            if (z) {
                nz.setValue(z.value)
            }
        },
        z => layer.removeZone(z),
        splitOnExistingZones,
        minimumArea
    )

}

